// extracted by mini-css-extract-plugin
var _1 = "TableCellEmpty-moduleTableCellEmpty__HKiPi";
export { _1 as "TableCellEmpty" }
